import { render, staticRenderFns } from "./AlacakForm.vue?vue&type=template&id=c37201ca&scoped=true"
import script from "./AlacakForm.vue?vue&type=script&lang=ts"
export * from "./AlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37201ca",
  null
  
)

export default component.exports